import React from "react";
import DashboardIcon from "../assets/SidebarDashboardIcon.svg";
import RolesIcon from "../assets/SidebarRolesIcon.svg";
import UsersIcon from "../assets/SidebarUsersIcon.svg";
import GroupsIcon from "../assets/SidebarGroupsIcon.svg";
import EventsIcon from "../assets/SidebarEventIcon.svg";
import RanksIcon from "../assets/SidebarRanksIcon.svg";
import MessageIcon from "../assets/SidebarMessagesIcon.svg";

import {
  ALLMESSAGESPATH,
  ASSEMBLYCONSTITUENCYPATH,
  BASE,
  EVENTPATH,
  GROUPPATH,
  RANKPATH,
  RIOPATH,
  ROLESPATH,
  USERSPATH,
} from "../routes/routePaths";
import { commonStrings } from "../static/commonStrings";

const env = process.env.REACT_APP_ENV || "local";

export const baseUrl =
  env === "local"
    ? process.env.REACT_APP_LOCAL_API!
    : env === "dev"
    ? process.env.REACT_APP_DEV_API!
    : env === "prod"
    ? process.env.REACT_APP_PROD_API!
    : process.env.REACT_APP_STAGING_API!;

export const socketUrl =
  env === "local"
    ? process.env.REACT_APP_LOCAL_SOCKET!
    : env === "dev"
    ? process.env.REACT_APP_DEV_SOCKET!
    : env === "prod"
    ? process.env.REACT_APP_PROD_SOCKET!
    : process.env.REACT_APP_STAGING_SOCKET!;

export const VIOLET = {
  dark: "#726AED",
  moderate: "#CDCAFF",
  light: "#AEA9FF",
};

export const GRAY = {
  light: "#F6F8FE",
  dark: "#B3B3B3",
  moderate: "#E8F1F8",
};

export const WHITE = {
  light: "#F5F5F5",
  main: "#FFFFFF",
  moderate: "#F6F8FE",
};

export const RED = {
  main: "#FF0E0E",
};

export const BLUE = {
  dark: "#234B89",
};

export const BROWN = {
  dark: "#C9AB71",
  light: "#C9AB7159",
  moderate: "#A08E67",
};

export const colorOptions = [
  { label: "Red", value: "red", chipColor: "#e53935" },
  { label: "Blue", value: "blue", chipColor: "#1e88e5" },
  { label: "Green", value: "green", chipColor: "#43a047" },
  { label: "Orange", value: "orange", chipColor: "#fb8c00" },
  { label: "Gray", value: "gray", chipColor: "#9e9e9e" },
  { label: "Yellow", value: "yellow", chipColor: "#fdd835" },
  { label: "Purple", value: "purple", chipColor: "#8e24aa" },
  { label: "Teal", value: "teal", chipColor: "#00897b" },
  { label: "Amber", value: "amber", chipColor: "#ffca28" },
  { label: "Pink", value: "pink", chipColor: "#d81b60" },
  { label: "Indigo", value: "indigo", chipColor: "#3949ab" },
  { label: "Cyan", value: "cyan", chipColor: "#00acc1" },
  { label: "Lime", value: "lime", chipColor: "#c0ca33" },
];

export interface MenuItem {
  id: number;
  to: string;
  text: string;
  Icon: React.ElementType | string;
  path: string;
}

export const menuItems: MenuItem[] = [
  {
    id: 1,
    to: BASE,
    text: "Dashboard",
    Icon: DashboardIcon,
    path: "",
  },
  { id: 2, to: ROLESPATH, text: "Roles", Icon: RolesIcon, path: "roles" },
  { id: 3, to: USERSPATH, text: "Users", Icon: UsersIcon, path: "users" },
  { id: 4, to: GROUPPATH, text: "Groups", Icon: GroupsIcon, path: "groups" },
  {
    id: 5,
    to: EVENTPATH,
    text: "Events",
    Icon: EventsIcon,
    path: "events",
  },
  {
    id: 6,
    to: RANKPATH,
    text: "Ranks",
    Icon: RanksIcon,
    path: "ranks",
  },
  {
    id: 7,
    to: ALLMESSAGESPATH,
    text: "Messages",
    Icon: MessageIcon,
    path: "allmessages",
  },
  {
    id: 8,
    to: RIOPATH,
    text: commonStrings.sideBarMenuTitles.rio,
    Icon: RolesIcon,
    path: "rio",
  },
];

export const PasswordRegExp = {
  uppercaseRegExp: /(?=.*?[A-Z])/,
  lowercaseRegExp: /(?=.*?[a-z])/,
  digitsRegExp: /(?=.*?[0-9])/,
  minLengthRegExp: /.{8,}/,
  specialCharRegExp: /(?=.*?[^\w\s])|(?=.*?\s)/,
};

export const PasswordErrMsg = {
  empty: "Password is empty",
  upperCase: "At least one Uppercase",
  lowerCase: "At least one Lowercase",
  digits: "At least one digit",
  minCharacter: "Password should contain minimum 8 characters",
  strongPassword: "That looks great. Strong Password !",
  error: "Please enter a strong password !",
  specialChar: "At least one special character or space",
};

export const PasswordCriteria = [
  "At least 8 Characters",
  "At least 1 upper case letter (A-Z)",
  "At least 1 lower case letter (a-z)",
  "At least 1 number (0-9)",
  "At least 1 special character or space",
];

// Placeholder for BLUE, GRAY, WHITE (replace with actual values)
export const BLUEE = {
  dark: "#1976D2",
};
export const GRAYY = {
  light: "#F5F5F5",
  dark: "#616161",
};
export const WHITEE = {
  main: "#FFFFFF",
  moderate: "#FAFAFA",
};

export const colors = {
  brownYellowColor: "#CDA767",
  scarletColor: "#E5322D",
  indigoBlueColor: "#3B4B91",
  lightSlateBlueColor: "#7F8ACA",
  white: "#FFFFFF",
  aliceBlueColor: "#F0F2FF",
  black: "#000000",
  brightGrayColor: "#EDEDED",
  cobaltBlueColor: "#0255A7 ",
  jetColor: "#343434",
  spanishGrayColor: "#959595",
};

export const FILTER_PAGE_SIZE = 10;
